import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { useAuth } from '../../../app/providers/useAuth';
import { cancelSubscription } from '../api/billingApi';

// PARA-131 (AC-12) — отмена автопродления. При 503 (AC-E4) локальное состояние
// не меняется: backend подписку тоже не менял, расходиться с Telegram нельзя.
export function useCancelSubscription(): UseMutationResult<void, Error, void> {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['billing', 'me', user?.id] });
    },
  });
}
